import {
  customerDetailsBusinessTranslation,
  CustomerDetailsBusinessTranslation,
} from '@/assets/locales/views/customerDetails/business/customerDetails.business.translation.pl.ts';
import {
  customerDetailsContactsTranslation,
  CustomerDetailsContactsTranslation,
} from '@/assets/locales/views/customerDetails/contacts/customerDetails.tasks.translation.pl.ts';
import {
  customerDetailsHeaderTranslation,
  CustomerDetailsHeaderTranslation,
} from '@/assets/locales/views/customerDetails/header/customerDetails.header.translation.pl.ts';
import {
  customerDetailsIndividualTranslation,
  CustomerDetailsIndividualTranslation,
} from '@/assets/locales/views/customerDetails/individual/customerDetails.individual.translation.pl.ts';
import {
  customerDetailsProcessesTranslation,
  CustomerDetailsProcessesTranslation,
} from '@/assets/locales/views/customerDetails/processes/customerDetails.processes.translation.pl.ts';
import {
  customerDetailsTabsTranslation,
  CustomerDetailsTabsTranslation,
} from '@/assets/locales/views/customerDetails/tabs/customerDetails.tabs.translation.pl.ts';
import {
  customerDetailsTasksTranslation,
  CustomerDetailsTasksTranslation,
} from '@/assets/locales/views/customerDetails/tasks/customerDetails.tasks.translation.pl.ts';

export type CustomerDetailsTranslation = {
  business: CustomerDetailsBusinessTranslation;
  contacts: CustomerDetailsContactsTranslation;
  header: CustomerDetailsHeaderTranslation;
  individual: CustomerDetailsIndividualTranslation;
  processes: CustomerDetailsProcessesTranslation;
  tabs: CustomerDetailsTabsTranslation;
  tasks: CustomerDetailsTasksTranslation;
};

export const customerDetailsTranslation: CustomerDetailsTranslation = {
  business: customerDetailsBusinessTranslation,
  contacts: customerDetailsContactsTranslation,
  header: customerDetailsHeaderTranslation,
  individual: customerDetailsIndividualTranslation,
  processes: customerDetailsProcessesTranslation,
  tabs: customerDetailsTabsTranslation,
  tasks: customerDetailsTasksTranslation,
};
